<template>
  <div class="store-detail" ref="parentScroll">
    <AppNavBar :title="storeData.store_name" :placeholder="true" :zIndex="2" />
    <div class="store-content" v-if="storeData">
      <img
        @click="bindPreviewImage"
        class="store-image"
        :src="storeData.store_images"
        alt=""
      />
      <div class="store-wrapper">
        <div class="store-top">
          <img
            class="logo"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/ede318c6e1f652e8760835a4ba7aef8c_wh=459_39.png"
            alt=""
          />
          <div class="store-info">
            <div class="store-name">{{ storeData.store_name }}</div>
            <div class="flower-info">
              <img
                class="flower-image"
                src="https://btw-common-data.betterwestar.com/btw-admin/resource/71ba3142596f4cf6b18e50e08fa3ca17_wh=66_66.png"
                alt=""
              />
              <div class="flower-num">{{ storeData.vote_num }}</div>
            </div>
          </div>
          <div class="address-content">
            <div class="iconfont icon-dingwei"></div>
            <div class="address">{{ storeData.store_address }}</div>
          </div>
        </div>
        <div class="bottom" :style="{ height: bottomContentHeight + 'px' }">
          <van-tabs
            v-model="active"
            @change="bindTabChange"
            :line-width="tabData[active].title.length * 16 + 'px'"
          >
            <van-tab
              :title="item.title"
              v-for="(item, index) in tabData"
              :key="index"
              :badge="index == 1 ? 'HOT' : ''"
            >
              <div
                class="page-view"
                :style="{ height: bottomContentHeight - 35 + 'px' }"
              >
                <div
                  class="page-scroll"
                  ref="childScroll"
                  :class="{ 'page-scorll-disabled': !item.scroll }"
                >
                  <CoachRank
                    :scroll="item.scroll"
                    :storeId="storeData.store_id"
                    v-if="index == 0"
                  ></CoachRank>
                  <UgcComponent
                    :scroll="item.scroll"
                    :storeId="storeData.store_id"
                    v-if="index == 1"
                  />
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
import CoachRank from './components/pageview-store-detail-coach-rank.vue'
import UgcComponent from './components/ugc.vue'
import { ImagePreview } from 'vant'
export default {
  components: { AppNavBar, CoachRank, UgcComponent },
  data() {
    return {
      active: 0,
      bottomContentHeight: 0,
      storeData: null,
      tabData: [
        {
          id: 1,
          title: '教练榜',
          scroll: false
        },
        {
          id: 2,
          title: '精选瞬间',
          scroll: false
        }
      ]
    }
  },
  created() {
    this.getParams()
    this.getBottomContentHeight()
  },
  methods: {
    bindPreviewImage() {
      if (this.storeData.store_images) {
        ImagePreview([this.storeData.store_images])
      }
    },
    getParams() {
      let params = Object.assign({}, this.$route.query)
      this.storeData = params
      this.$nextTick(() => {
        this.$refs.parentScroll.addEventListener('scroll', this.bindScroll, {
          passive: false
        })
      })
    },
    async getBottomContentHeight() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.tabBarHeight = res.toolsBarHeight
          this.statusBarHeight = res.statusBarHeight
          this.bottomContentHeight =
            window.innerHeight - (this.tabBarHeight + this.statusBarHeight)
        }
      } else {
        this.tabBarHeight = 40
        this.statusBarHeight = 20
        this.bottomContentHeight =
          window.innerHeight - (this.tabBarHeight + this.statusBarHeight)
      }
    },
    bindScroll(e) {
      let el = e.target
      let isBottom =
        Math.round(el.scrollTop) >= el.scrollHeight - el.offsetHeight - 1
      let minHeight = 50
      let maxHeight = 100
      var scroll = e.target.scrollTop
      this.$set(this.tabData[this.active], 'scroll', isBottom)
      if (scroll < minHeight) {
        this.navBarOpacity = 0
      }
      if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        let pecent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = pecent
      }
    },
    bindTabChange(value) {
      let el = this.$refs.parentScroll
      let isBottom = el.scrollTop >= el.scrollHeight - el.offsetHeight
      this.tabData[this.active].scroll = isBottom
    },
    bindToDynamic() {}
  }
}
</script>
<style lang="scss" scoped>
.store-detail {
  height: 100vh;
  overflow-y: scroll;
  overscroll-behavior: none;
  .store-content {
    .store-image {
      object-fit: cover;
      width: 100%;
      height: 193px;
    }
    .store-wrapper {
      position: relative;
      z-index: 1;
      background: #ffffff;
      border-radius: 12px 12px 0px 0px;
      margin-top: -12px;
      .store-top {
        padding: 20px 20px 0px;
      }
      .logo {
        height: 13px;
        margin-bottom: 7px;
      }
      .store-info {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        .store-name {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
          font-size: 20px;
          color: #303038;
          line-height: 28px;
          margin-right: 5px;
        }
        .flower-info {
          display: flex;
          align-items: center;
          .flower-image {
            width: 15px;
            height: 15px;
            object-fit: contain;
            margin-right: 3px;
          }
          .flower-num {
            font-family: DIN;
            font-weight: bold;
            font-size: 16px;
            color: #ff2270;
            line-height: 21px;
          }
        }
      }
      .address-content {
        background: #f7f7f7;
        border-radius: 4px;
        padding: 6px 14px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .iconfont {
          color: rgb(174, 175, 184);
          margin-right: 14px;
        }
        .address {
          font-size: 12px;
          color: rgba(48, 48, 56, 0.7);
          line-height: 16px;
        }
      }
    }
  }
  .bottom {
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;
  }
  .page-view {
    height: calc(100vh - 121px);
    .page-scroll {
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .item {
        height: 50px;
        border-bottom: 1px solid #ececec;
      }
    }
    .page-scorll-disabled {
      overflow-y: hidden;
    }
  }
  ::v-deep .van-tabs__wrap {
    padding-top: 16px;
    //padding-top: 1s0px;
    position: relative;
    height: 25px;
  }
  ::v-deep .van-tabs__nav {
    padding-left: 6px;
    padding-right: 6px;
    position: relative;
    z-index: 3;
    background-color: transparent;
    .van-info {
      top: -4px;
      right: -1px;
      padding: 0px 4px 0px 3px;
      height: 14px;
      background: #ff2270;
      border-radius: 8px 8px 8px 0px;
      font-family: GothamBlack;
      font-weight: normal;
      font-style: italic;
      font-size: 10px;
      color: #ffffff;
      line-height: 14px;
    }
  }
  ::v-deep .van-tab {
    flex: 0 0 auto;
    padding: 0px 14px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(5, 11, 39, 0.5);
    line-height: 22px;
  }
  ::v-deep .van-tab--active {
    font-weight: bold;
    font-size: 16px;
    color: #050b27;
    line-height: 22px;
  }
  ::v-deep .van-tabs__line {
    width: 80px;
    height: 9px;
    z-index: -1;
    background-color: #ffeabd;
  }
}
</style>
